module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as2613-fb138ebd372f1f37736029d65a12a57c.jpg";